import { computed, type MaybeRef, toValue } from 'vue'
import { RepurchasedContractType } from '../../Constants/RepurchasedContractType.ts'
import type {
  ExternalRepurchasedContract,
  OutstandingRepurchaseAction,
  RepurchasedContract,
} from '../../Types/restructuring'

export default function useOutstandingRepurchase(action: MaybeRef<OutstandingRepurchaseAction>) {
  const contracts = computed<RepurchasedContract[]>(() =>
    toValue(action).contracts.filter((contract) => contract.type === RepurchasedContractType.default),
  )
  const externalContracts = computed<ExternalRepurchasedContract[]>(() =>
    toValue(action).contracts.filter((contract) => contract.type === RepurchasedContractType.external),
  )

  const externalRepurchaseAmount = computed(() =>
    externalContracts.value.reduce((total, { repurchaseAmount }) => total + Number(repurchaseAmount), 0),
  )

  const contractRepurchaseAmount = computed(() =>
    contracts.value.reduce((total, { repurchaseAmount }) => total + Number(repurchaseAmount), 0),
  )

  const totalRepurchaseAmount = computed(() => externalRepurchaseAmount.value + contractRepurchaseAmount.value)

  return {
    contracts,
    externalContracts,
    externalRepurchaseAmount,
    contractRepurchaseAmount,
    totalRepurchaseAmount,
  }
}
